import React, { useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ButtonGroup, Button } from "react-bootstrap"
import { api, getBranchOwner, get } from "@config"
import { AutoComplete, Modas } from 'antd';
const { Option } = AutoComplete

import { setCfop } from '../actions'
import { setLoading } from '@inspinia-react/actions';
import { mapTest } from '../../../products/map.test'

function CFOP(props) {
    const branch = getBranchOwner().id
    const [result, setResult] = React.useState([])
    const [code, setCode] = React.useState()
    const [input, setInput] = React.useState('')

    function search(e) {
        e = e.replace('.', '').replace('.', '').replace('.', '').replace('-', '').replace('-', '')
        setInput(e)
        if (e === "") {
            props.setCfop({})
            return
        }
        if (e.length < 4) return
        const searchBy = isNaN(e) ? "description" : "code";
        const url = `${api.products.cfop}?branch_owner=${branch}&${searchBy}=${e}`;
        const payload = data => {
            setResult(data)
        };
        get(url, payload);
    }

    function onSelect(e) {
        const obj = JSON.parse(e)
        props.setCfop(obj)
        _callHandle(e)

    }
    function _callHandle(cfop){
        if(props.handleSelect){
            if( typeof props.handleSelect === "function"){
                props.handleSelect(cfop)
            }
        }
    }

    function getCode(code) {
        if (Number(props.cfop.code) === code) {
            return
        }
        props.setLoading(true)

        const url = `${api.products.cfop}?branch_owner=${branch}&code=${code}`;
        const payload = data => {
            props.setCfop(data[0])
            setInput(data[0].description)
            props.setLoading(false)
            _callHandle(JSON.stringify(data[0]))
        };
        const errPayload = err => {
            props.setLoading(false)
        }

        get(url, payload, errPayload);
    }

    React.useEffect(() => {
        if (props.cfop) {
            setInput(props.cfop.description);
        }
    }, [props.cfop])

    return <React.Fragment>
        <p className="lead mb-1">CFOP {props.cfop.code}</p>
        <AutoComplete
            value={input}
            allowClear
            id={mapTest.createProduct.cfop.input}
            style={{ width: 300 }}
            onSelect={onSelect}
            onSearch={search}
            disabled={props.loading}
            placeholder="Busque pelo nome ou código"
            options={result}
        >
            {
                result.map(item => <Option key={item.id} value={JSON.stringify(item)}>
                    {item.code} | {item.description.substr(0, 100)}
                </Option>)
            }
        </AutoComplete>
        <p className="my-2">
            Sugestões
        </p>
        <ButtonGroup className="w-100">
            {/* <Button disabled={props.loading} id={mapTest.createProduct.cfop.buttonSelect5101} onClick={() => getCode(5101)} >
                5101
            </Button> */}
            <Button disabled={props.loading} id={mapTest.createProduct.cfop.buttonSelect5102} onClick={() => getCode(5102)} >
                5102
            </Button>
        </ButtonGroup>
    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading,
    cfop: state.cfop
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setCfop,
    setLoading
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CFOP)



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/cfop/index.jsx